import base from "/Users/a/Desktop/Code/frontend/monochrome/images/twitter.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");